import { useEffect, useState } from "react";
import { Play } from "lucide-react";
import { AI_VOICES, maleVoices, saveVoiceName, savedVoiceName, speak } from "@/edgar/voice";

// Pick and preview Edgar's voice from the natural male voices on this device.
export default function VoicePicker() {
  const [list, setList] = useState([]);
  const [name, setName] = useState(savedVoiceName);
  useEffect(() => {
    const load = () => setList(maleVoices());
    load();
    window.speechSynthesis?.addEventListener?.("voiceschanged", load);
    return () => window.speechSynthesis?.removeEventListener?.("voiceschanged", load);
  }, []);
  const current = name.startsWith("ai:") ? name : list.find((v) => v.name === name)?.name || (name ? list[0]?.name : "ai:onyx") || "ai:onyx";
  const pick = (n) => { setName(n); saveVoiceName(n); };
  return (
    <span className="inline-flex min-w-0 items-center gap-1" data-testid="edgar-voice-picker">
      <select value={current} onChange={(e) => pick(e.target.value)} aria-label="Edgar's voice" data-testid="edgar-voice-select"
        className="h-7 min-w-0 max-w-[170px] truncate rounded-full border border-slate-300 bg-white px-2 text-[11px] text-slate-700">
        <optgroup label="Natural AI voices">
          {AI_VOICES.map(([id, label]) => <option key={id} value={`ai:${id}`}>{label}</option>)}
        </optgroup>
        {list.length > 0 && <optgroup label="Free device voices">
          {list.map((v) => <option key={v.name} value={v.name}>{v.name.replace(/^Microsoft |^Google /, "").replace(/ - English.*| \(.*\)$/g, "")}{/natural|neural|enhanced|premium|online/i.test(v.name) ? " ★" : ""}</option>)}
        </optgroup>}
      </select>
      <button type="button" onClick={() => speak("Hi, I'm Edgar. Let's find something worth flipping.")} aria-label="Play a sample" data-testid="edgar-voice-play"
        className="inline-flex h-7 w-7 items-center justify-center rounded-full border border-slate-300 text-slate-700 transition-colors hover:border-[#0053DA] hover:text-[#0053DA]">
        <Play className="h-3 w-3" />
      </button>
    </span>
  );
}
